import React from 'react'

import LandingTemplatesContainer from '../components/landing-templates/LandingTemplatesContainer'

const LandingTemplatesScreen = props => <LandingTemplatesContainer {...props} />

export default LandingTemplatesScreen
